import { Component, effect, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSonnerToaster } from 'ngx-sonner';
import { DesktopMessageComponent } from "./shared/desktop-message/desktop-message.component";
import { LoaderComponent } from "./shared/loader/loader.component";
import { LoaderService } from './services/loader.service';
import { ButtonHelpComponent } from './shared/button-help/button-help.component';
import { HelpService } from './services/help.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgxSonnerToaster, DesktopMessageComponent, LoaderComponent, ButtonHelpComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit{
  protected title = 'Vinculaciones Fincomercio';
  isMobile = signal<boolean>(false);

  _loaderService = inject(LoaderService);
  _helpService = inject(HelpService);

  constructor() {
  }

  ngOnInit() {
    this.checkDevice();
    window.addEventListener('resize', () => this.checkDevice());
  }

  checkDevice() {
    this.isMobile.set(window.matchMedia('(max-width: 768px)').matches);
  }

}
